"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _clsx = _interopRequireDefault(require("clsx"));
var _Image = _interopRequireDefault(require("../Image"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      display: 'flex',
      alignItems: 'flex-start'
    },
    image: {
      width: '100px',
      height: 'auto',
      display: 'inline-block',
      marginRight: theme.spacing(4),
      flexShrink: 0
    },
    name: {
      fontWeight: theme.typography.fontWeightMedium,
      '&$name': {
        fontSize: theme.typography.pxToRem(16)
      }
    },
    text: {
      '& p': (0, _defineProperty2.default)({
        fontSize: theme.typography.pxToRem(14)
      }, theme.breakpoints.up('md'), {
        lineHeight: 1.43
      }),
      display: 'inline-block',
      verticalAlign: 'top',
      flexGrow: 1
    },
    employmentDetail: {
      '&$employmentDetail': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
});
var imageStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      '& img': {
        height: '100px',
        width: '100px'
      }
    }
  };
});
var Speaker = function Speaker(_ref) {
  var image = _ref.image,
    name = _ref.name,
    company = _ref.company,
    title = _ref.title,
    injectedWrapperClass = _ref.injectedWrapperClass;
  var imageClasses = imageStyles();
  var classes = useStyles();
  return __jsx("div", {
    className: (0, _clsx.default)(classes.wrapper, injectedWrapperClass)
  }, __jsx("div", {
    className: classes.image
  }, image && __jsx(_Image.default, (0, _extends2.default)({}, image, {
    classesInjected: imageClasses
  }))), __jsx("div", {
    className: classes.text
  }, name && __jsx(_core.Typography, {
    className: classes.name,
    dangerouslySetInnerHTML: {
      __html: name
    }
  }), company && __jsx(_core.Typography, {
    className: classes.employmentDetail,
    dangerouslySetInnerHTML: {
      __html: company
    }
  }), title && __jsx(_core.Typography, {
    className: classes.employmentDetail,
    dangerouslySetInnerHTML: {
      __html: title
    }
  })));
};
var _default = Speaker;
exports.default = _default;